/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createProductFromDiscriminatorValue, serializeProduct, serializeUpdateProductImagesRequest, type ErrorResponse, type InternalErrorResponse, type Product, type UpdateProductImagesRequest } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/products/images
 */
export interface ImagesRequestBuilder extends BaseRequestBuilder<ImagesRequestBuilder> {
    /**
     * Replaces the product's image assignments with the given image ids, in the given order — position 0 becomes the default thumbnail. Omitting a currently-assigned image removes it from the product (the image itself stays in the image library); an empty list removes them all. Only images already assigned to the product may appear: an unknown or repeated image id is a 400 naming the id. Uploading new images stays with POST /api/images/from-local. For an agency organization a vendorCode names the line the product belongs to and the SKU is matched as {vendorCode}-{sku}, the way the product import stores it, a value already carrying the prefix being left alone; the vendorCode must be one of the organization's vendors. Without a vendorCode the SKU is used exactly as given.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Product>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: UpdateProductImagesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Product | undefined>;
    /**
     * Replaces the product's image assignments with the given image ids, in the given order — position 0 becomes the default thumbnail. Omitting a currently-assigned image removes it from the product (the image itself stays in the image library); an empty list removes them all. Only images already assigned to the product may appear: an unknown or repeated image id is a 400 naming the id. Uploading new images stays with POST /api/images/from-local. For an agency organization a vendorCode names the line the product belongs to and the SKU is matched as {vendorCode}-{sku}, the way the product import stores it, a value already carrying the prefix being left alone; the vendorCode must be one of the organization's vendors. Without a vendorCode the SKU is used exactly as given.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateProductImagesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ImagesRequestBuilderUriTemplate = "{+baseurl}/api/products/images";
/**
 * Metadata for all the requests in the request builder.
 */
export const ImagesRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: ImagesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createProductFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateProductImagesRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
